import { render, staticRenderFns } from "./Prize_order_form.vue?vue&type=template&id=22afd36a&scoped=true"
import script from "./Prize_order_form.vue?vue&type=script&lang=js"
export * from "./Prize_order_form.vue?vue&type=script&lang=js"
import style0 from "./Prize_order_form.vue?vue&type=style&index=0&id=22afd36a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22afd36a",
  null
  
)

export default component.exports